import { render, staticRenderFns } from "./customerMapDetail.vue?vue&type=template&id=37c39b27&scoped=true&"
import script from "./customerMapDetail.vue?vue&type=script&lang=js&"
export * from "./customerMapDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c39b27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c39b27')) {
      api.createRecord('37c39b27', component.options)
    } else {
      api.reload('37c39b27', component.options)
    }
    module.hot.accept("./customerMapDetail.vue?vue&type=template&id=37c39b27&scoped=true&", function () {
      api.rerender('37c39b27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/clue/customerMap/customerMapDetail.vue"
export default component.exports